import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setAuthRedirectPath } from '../store/userSlice';

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(state => state.user);
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(setAuthRedirectPath(location.pathname + location.search));
    }
  }, [dispatch, isAuthenticated, location.pathname, location.search]);

  if (!isAuthenticated) {
    return <Navigate to="/authorization" replace />;
  }

  return children;
};

export default ProtectedRoute;